<template>
  <nav class="navbar navbar-expand-lg fixed-top bg-white" id="main-navbar">
    <router-link class="navbar-brand mr-auto mr-lg-0" to="/" v-on:click.native="menuClick">
      <img src="/assets/images/logo/my-logo.svg" width="200" alt="me&you Mobile Logo" />
    </router-link>

    <router-link
      class="shopping-cart-mobile mr-4 lg-none"
      to="/checkout"
      v-on:click.native="menuClick"
    >
      <i class="fa fa-shopping-cart"></i>
      <span class="badge badge-pill badge-dark" v-if="cartCount > 0">{{ cartCount }}</span>
    </router-link>

    <button
      class="hamburger hamburger--collapse navbar-toggler border-0"
      type="button"
      data-toggle="offcanvas"
      v-on:click="showMobileMenu = !showMobileMenu"
      v-bind:class="{ 'is-active': showMobileMenu }"
    >
      <span class="hamburger-box">
        <span class="hamburger-inner"></span>
      </span>
    </button>

    <div class="navbar-collapse offcanvas-collapse" v-bind:class="{ open: showMobileMenu }">
      <div class="navbar-collapse-inner">
        <ul class="navbar-nav mr-auto">
          <li class="nav-item"></li>
        </ul>
        <ul class="navbar-nav align-items-center justify-content-end">
          <li class="nav-item active" v-if="!isAuthenticated">
            <router-link class="nav-link" to="/activate" v-on:click.native="menuClick">Activate</router-link>
          </li>
          <li class="nav-item dropdown mobile-dropdown">
            <a
              class="nav-link dropdown-toggle"
              href="#"
              id="navbarDropdown"
              role="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >Mobile</a>
            <div class="dropdown-menu" aria-labelledby="navbarDropdown">
              <router-link
                class="dropdown-item nav-link"
                :to="{ name: 'mobile-hot-deals', params: { builder: false }}"
                v-on:click.native="menuClick"
              >Hot Deals</router-link>
              <router-link
                class="dropdown-item nav-link"
                :to="{ name: 'mobile-build-your-deal', params: { builder: true }}"
                v-on:click.native="menuClick"
              >Build Your Deal</router-link>
              <router-link
                class="dropdown-item nav-link"
                :to="{ name: 'recharge', params: { builder: true }}"
                v-on:click.native="menuClick"
              >Recharge</router-link>
              <router-link
                class="dropdown-item nav-link"
                :to="{ name: 'mobile-faqs' }"
                v-on:click.native="menuClick"
              >FAQs</router-link>
            </div>
          </li>
          <li class="nav-item dropdown mobile-dropdown">
            <a
              class="nav-link dropdown-toggle"
              href="#"
              id="navbarDropdown"
              role="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >Fixed LTE</a>
            <div class="dropdown-menu" aria-labelledby="navbarDropdown">
              <router-link
                class="dropdown-item nav-link"
                :to="{ name: 'fixed-lte-signup', params: { builder: false }}"
                v-on:click.native="menuClick"
              >Sign Up</router-link>              
              <router-link  v-if="!isAuthenticated"
                class="dropdown-item nav-link"
                :to="{ name: 'fixed-lte-recharge' }"
                v-on:click.native="menuClick"
              >Top up</router-link>
              <router-link v-if="isAuthenticated" class="dropdown-item nav-link" to="/backend.html" v-on:click.native="menuClick">Top up</router-link>
              <router-link
                class="dropdown-item nav-link"
                :to="{ name: 'fixed-lte-faqs' }"
                v-on:click.native="menuClick"
              >FAQs</router-link>
            </div>
          </li>          
          <li class="nav-item">
            <router-link class="nav-link" to="/recharge" v-on:click.native="menuClick">Recharge</router-link>
          </li>
          <li class="nav-item" v-if="isAuthenticated">
            <a class="nav-link" href="/backend.html">Manage Profile</a>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/contact-us" v-on:click.native="menuClick">Contact Us</router-link>
          </li>
          <li class="nav-item nav-cart">
            <router-link class="nav-link" to="/checkout" v-on:click.native="menuClick">
              <i class="fa fa-shopping-cart"></i>
              <span
                class="badge badge-pill badge-dark d-none d-lg-inline"
                v-if="cartCount > 0"
              >{{ cartCount }}</span>
              <span class="pl-2 d-lg-none">Cart</span>
            </router-link>
          </li>
          <li class="nav-item dropdown nav-login" v-if="!isAuthenticated">
            <a
              class="nav-link dropdown-toggle"
              href="javascript:void(0)"
              id="login-dropdown"
              v-on:click="showLoginForm = !showLoginForm"
            >
              <span v-if="!isForgotPassword || !showMobileMenu">Login</span>
              <span v-if="isForgotPassword && showMobileMenu">Forgot Password</span>
            </a>
            <div
              class="dropdown-menu"
              aria-labelledby="login-dropdown"
              v-bind:class="{ show: showLoginForm }"
            >
              <vue-loading :active.sync="is_working" :can-cancel="false" :is-full-page="false"></vue-loading>
              <div class="login-details">
                <vue-login
                  redirect="/backend.html"
                  @forgotPasswordChangedEvent="forgotPasswordChanged"
                ></vue-login>
              </div>
            </div>
          </li>
          <li class="nav-item nav-login" v-if="isAuthenticated">
            <a class="nav-link" href="javascript:void(0)" id="login-dropdown" @click="logout">Logout</a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
import VueLogin from "../elements/vue-login.vue";
import { mapGetters } from "vuex";
import store from "@/store";

import { USER_LOGOUT } from "@/store/actions.type";

export default {
  name: "site-navigation",
  components: {
    "vue-login": VueLogin
  },
  computed: {
    ...mapGetters(["cartSims", "isAuthenticated"])
  },
  data: function() {
    return {
      cartCount: 0,
      showMobileMenu: false,
      showLoginForm: false,
      isForgotPassword: false,
      is_working: false
    };
  },
  methods: {
    menuClick(event) {
      var self = this;
      self.$emit("navigation-menu-click", { event: event });
      self.showMobileMenu = false;
      self.showLoginForm = false;
    },
    forgotPasswordChanged() {
      var self = this;
      self.$log.debug("Handle Forgot Password Changed");
      self.isForgotPassword = !self.isForgotPassword;
    },
    logout() {
      store.dispatch(USER_LOGOUT);
    }
  },
  watch: {
    cartSims: function(newValue) {
      var self = this;
      self.$log.debug("CART SIMs", newValue);
      self.cartCount = newValue.length;
    }
  },
  mounted() {
    var self = this;
    self.cartCount = self.cartSims.length;
  }
};
</script>


